import { compose } from '@reduxjs/toolkit';
import { arrangeNavigationItemReducer, createNavigationItemReducer, editNavigationItemReducer } from './hierarchy-item';
import {
  arrangeNavigationSubitemReducer,
  createNavigationSubitemReducer,
  editNavigationSubitemReducer,
} from './hierarchy-subitem';
import {
  createNavigationTreeReducer,
  duplicateNavigationTreeReducer,
  editNavigationTreeReducer,
  fetchNavigationTreesReducer,
  fetchTreesAlternativeLoadingReducer,
} from './navigation-tree';
import { fetchCategoriesReducer, fetchPriceGroupsReducer } from './options';

export const extraReducers = compose(
  arrangeNavigationItemReducer,
  arrangeNavigationSubitemReducer,
  createNavigationTreeReducer,
  editNavigationTreeReducer,
  fetchNavigationTreesReducer,
  fetchPriceGroupsReducer,
  createNavigationItemReducer,
  editNavigationItemReducer,
  duplicateNavigationTreeReducer,
  fetchTreesAlternativeLoadingReducer,
  createNavigationSubitemReducer,
  editNavigationSubitemReducer,
  fetchCategoriesReducer,
);
export { arrangeNavigationItem, createNavigationItem, editNavigationItem } from './hierarchy-item';
export { arrangeNavigationSubitem, createNavigationSubitem, editNavigationSubitem } from './hierarchy-subitem';
export {
  createNavigationTree,
  duplicateNavigationTree,
  editNavigationTree,
  fetchNavigationTrees,
  fetchTreesAlternativeLoading,
} from './navigation-tree';
export { fetchCategories, fetchPriceGroups } from './options';
